export default __webpack_public_path__ + "static/media/Use_Cases_list_NDAP.940818c1.pdf";